import _extends from "@babel/runtime-corejs3/helpers/extends";import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";var _excluded = ["width", "height", "autocompletePattern"];import React from 'react';
import { INPUT_OPTIONS_HEIGHT, INPUT_OPTIONS_SIZES } from "../../../utils/forms/dynamicFormsHelpers";
import { TextArea } from "../..";

import { createStyles } from "./styles";

var TextAreaOption = function TextAreaOption(_ref)




{var _ref$width = _ref.width,width = _ref$width === void 0 ? 'large' : _ref$width,_ref$height = _ref.height,height = _ref$height === void 0 ? 'medium' : _ref$height,autocompletePattern = _ref.autocompletePattern,props = _objectWithoutProperties(_ref, _excluded);
  var classes = createStyles();

  return /*#__PURE__*/(
    React.createElement(TextArea, _extends({},
    props, {
      width: INPUT_OPTIONS_SIZES[width],
      height: INPUT_OPTIONS_HEIGHT[height],
      description:
      autocompletePattern && /*#__PURE__*/React.createElement("span", { className: classes.description }, autocompletePattern) })));



};

export default TextAreaOption;
//# sourceMappingURL=index.js.map